module.exports = __webpack_public_path__ + "img/step-line-disabled.fc4514a4.svg";